import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class FactoringInvoiceService {
  private _savefactInvoiceUrl = `${environment.api}/factInvoice/factInvoiceSave`;
  private _updatefactInvoiceUrl = `${environment.api}/factInvoice/updatefactInvoice`;

  private _getFolderInfoUrl = `${environment.api}/factInvoice/getFolderInvoiceInfo`;

  private _updateCheckfact = `${environment.api}/factInvoice/updateCheckfact`;
  private _deleteFactInvoiceUrl = `${environment.api}/factInvoice/deleteFactInvoice`;
  private _createFactoringSoaUrl = `${environment.api}/factInvoice/createFactoringSoa`;

  private _changeFactStatusUrl = `${environment.api}/factInvoice/changeFactoringStatus`;

  private _sendEmailCustomerUrl = `${environment.api}/factInvoice/sendEmailToCustomer`;
  
  private _sendSoaEmailToCmpUrl = `${environment.api}/factInvoice/sendSoaEmailToCmp`;
  

  private _sendEmailFactoringSoaUrl = `${environment.api}/factInvoice/sendEmailFactoringSoa`;

  private _getSoaInfoByidUrl = `${environment.api}/factInvoice/getSoaInfoByid`;


  private _downloadSoaFileUrl = `${environment.api}/factInvoice/downloadSoaFile`;

  private _updateSoaByIdUrl = `${environment.api}/factInvoice/updateSoaById`;


  


  constructor(private http: HttpClient) { }

  getSoaInfoByid(data)
  {
     return this.http.post<any>(this._getSoaInfoByidUrl,data);
  }

  updateSoaMaster(data)
  {
     return this.http.post<any>(this._updateSoaByIdUrl,data);
  }


  
  downloadSoaFile(data)
  {
     return this.http.post<any>(this._downloadSoaFileUrl,data);
  }

  sendEmailFactoringSoa(data)
  {
     return this.http.post<any>(this._sendEmailFactoringSoaUrl,data);
  }

  factInvoiceSave(data)
  {
     return this.http.post<any>(this._savefactInvoiceUrl,data);
  }
  
  updatefactInvoice(data)
  {
     return this.http.post<any>(this._updatefactInvoiceUrl,data);
  }

  updateCheckfact(data){
    return this.http.post<any>(this._updateCheckfact,data);
  }
 
  getFolderInfo(data)
  {
    return this.http.post<any>(this._getFolderInfoUrl,data);
  }
  
  deleteFactInvoice(data){
    return this.http.post<any>(this._deleteFactInvoiceUrl,data);
  }

  createFactoringSoa(data){
    return this.http.post<any>(this._createFactoringSoaUrl,data);
  }

  changeFactoringStatus(data){
    return this.http.post<any>(this._changeFactStatusUrl,data);
  }

  sendEmailToCustomer(data)
  {
     return this.http.post<any>(this._sendEmailCustomerUrl,data);
  }
  


  sendSoaEmailToCmp(data)
  {
     return this.http.post<any>(this._sendSoaEmailToCmpUrl,data);
  }
  

  



  

}
